import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import userAgent from '@/services/userAgent.service';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationLinkItem',
  props: {
    name: null,
    link: null,
    isExternal: { type: Boolean }
  },
  setup(__props: any) {


let inView: boolean = userAgent.isPrerender;
const runAnimations: boolean = userAgent.isPrerender;

const theme = computed<Vertica.LouisPoulsen.Application.Mvc.Spa.ViewModels.PageDataViewModel.ColorTheme>(() => store.getters['app/theme']);

const borderColor = computed<OpacityFunction>(() => store.getters['app/borderColor']);
function setInView() {
    inView = true;
}
const addInitAnimationClasses = computed<boolean>(() => runAnimations || inView);


return { __sfc: true,inView, runAnimations, theme, borderColor, setInView, addInitAnimationClasses }
}

})